export default {
  text: {
    default: `var(--ehi-color-text)`,
    dark: `var(--ehi-color-text-dark)`,
    grey: `var(--ehi-color-text-grey)`,
    white: `var(--ehi-color-text-white)`,
    primary: `var(--ehi-color-text-primary)`,
    'primary-dark': `var(--ehi-color-text-primary-dark)`,
    error: `var(--ehi-color-text-error)`,
    alert: `var(--ehi-color-text-alert)`,
    inactive: `var(--ehi-color-text-inactive)`,
    link: `var(--ehi-color-link)`,
    'link-visited': `var(--ehi-color-link-visited)`,
    'icon-primary': `var(--ehi-color-icon-primary)`,
    'icon-secondary': `var(--ehi-color-icon-secondary)`,
    'icon-tertiary': `var(--ehi-color-icon-tertiary)`,
    'icon-warning': `var(--ehi-color-icon-warning)`,
    'icon-alert': `var(--ehi-color-icon-alert)`,
    'current-color': 'currentColor',
  },
  border: {
    neutral: `var(--ehi-color-border-neutral)`,
    white: `var(--ehi-color-border-white)`,
    light: `var(--ehi-color-border-light)`,
    dim: `var(--ehi-color-border-dim)`,
    warning: `var(--ehi-color-border-warning)`,
    primary: `var(--ehi-color-border-primary)`,
    'primary-light': `var(--ehi-color-border-primary-light)`,
    enabled: `var(--ehi-color-border-enabled)`,
    disabled: `var(--ehi-color-border-disabled)`,
    divider: `var(--ehi-color-border-divider)`,
    error: `var(--ehi-color-border-error)`,
    'current-color': 'currentColor',
  },
  background: {
    'surface-primary': `var(--ehi-color-background-surface-primary)`,
    'surface-primary-darker': `var(--ehi-color-background-surface-primary-darker)`,
    'surface-highlight': `var(--ehi-color-background-surface-highlight)`,
    'surface-error': `var(--ehi-color-background-surface-error)`,
    'surface-light': `var(--ehi-color-background-surface-light)`,
    'surface-shade': `var(--ehi-color-background-surface-shade)`,
    'surface-canvas': `var(--ehi-color-background-surface-canvas)`,
    'surface-dark': `var(--ehi-color-background-surface-dark)`,
    'surface-alert': `var(--ehi-color-background-surface-alert)`,
    'surface-400': `var(--ehi-color-background-surface-400)`,
    'surface-300': `var(--ehi-color-background-surface-300)`,
    'surface-200': `var(--ehi-color-background-surface-200)`,
    'surface-100': `var(--ehi-color-background-surface-100)`,
    'surface-50': `var(--ehi-color-background-surface-50)`,
    'surface-25': `var(--ehi-color-background-surface-25)`,
    'interactive-action': `var(--ehi-color-background-interactive-action)`,
    'interactive-action-hover': `var(--ehi-color-background-interactive-action-hover)`,
    'interactive-primary': `var(--ehi-color-background-interactive-primary)`,
    'interactive-white': `var(--ehi-color-background-interactive-white)`,
    'interactive-focus': `var(--ehi-color-background-interactive-focus)`,
    'interactive-selected': `var(--ehi-color-background-interactive-selected)`,
    'interactive-white-hover': `var(--ehi-color-background-interactive-white-hover)`,
    'interactive-dark': `var(--ehi-color-background-interactive-dark)`,
    'interactive-active': `var(--ehi-color-background-interactive-active)`,
    'interactive-error': `var(--ehi-color-background-interactive-error)`,
    'interactive-warning': `var(--ehi-color-background-interactive-warning)`,
    'current-color': 'currentColor',
  },
  accent: {
    primary: `var(--ehi-color-background-surface-primary)`,
    highlight: `var(--ehi-color-background-surface-highlight)`,
  },
};
